import { Button } from "../../../components/button/button";
import { Header } from "../../../components/header/header";
import { useAnimatedNavigate } from "../../../hooks/useAnimatedNavigate";
import { Policy } from "../../policy/policy";

export const DocumentsPage = () => {
    const navigate = useAnimatedNavigate();

    return (
        <>
            <Header title="Документы" />

            <Policy />

            <Button
                text="Вернуться"
                onClick={() => navigate(-1)}
            />
        </>
    );
}